import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function careersRouteI18n(): string {
  return (appRoutesI18nCache['careers'] ??= $localize`:url-segment@@careers-url-segment:careers`);
}
